import React, { useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { errorMessage, formatUsername } from "../../../util/Helpers";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { useDownloadUsersByHoldingTypeReportMutation } from "../../../../redux/apiSlice";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { Permission } from "../../Common/layout/Permission";
import { PARTNERS } from "../../../util/constants/Partners";

export const HoldingsTypeReportTable = () => {
  const tableRef = useRef();

  const [
    downloadUsersByHoldingReport,
    {
      isLoading: isLoadingReport,
      isSuccess: isReportGenerating,
      error: errorReport,
    },
  ] = useDownloadUsersByHoldingTypeReportMutation();

  useEffect(() => {
    if (errorReport) {
      cogoToast.error(errorReport.data);
    }
  }, [errorReport]);

  useEffect(() => {
    if (isReportGenerating) {
      cogoToast.success(
        `Report export in progress. The resulting file will be sent to your mail.`
      );
    }
  }, [isReportGenerating]);

  return (
    <div className="py-4 px-6">
      <FilterGroup defaultFilters={{ type: "cash and stocks" }}>
        <div className="d-flex">
          <div className={"mb-4 mr-4"}>
            <FilterGroup.Filter className={"mr-4"} name={"type"} label={"Type"}>
              <FilterGroup.Option value={"cash and stocks"}>
                Cash and Stocks
              </FilterGroup.Option>
              <FilterGroup.Option value={"cash only"}>
                Cash Only
              </FilterGroup.Option>
              <FilterGroup.Option value={"stocks only"}>
                Stocks Only
              </FilterGroup.Option>
            </FilterGroup.Filter>
          </div>
          <div className={"mb-4 mr-4"}>
            <FilterGroup.Filter
              className={"mr-4"}
              name={"partner"}
              label={"Partner"}
            >
              <FilterGroup.Option value={""}>All</FilterGroup.Option>
              {PARTNERS.map(({ name, value }) => (
                <FilterGroup.Option value={value}>{name}</FilterGroup.Option>
              ))}
            </FilterGroup.Filter>
          </div>
        </div>
        <FilterGroup.Content>
          {({ filters }) => {
            return (
              <Card>
                <CardHeader title={`Portfolios holding ${filters?.type}`}>
                  <Permission
                    permission={Permissions.REPORTS}
                    permissionType={PermissionType.CREATE}
                  >
                    <CardHeaderToolbar>
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={isLoadingReport}
                        onClick={() =>
                          downloadUsersByHoldingReport({
                            type: filters?.type,
                            partner: filters?.partner,
                          })
                        }
                      >
                        Export CSV
                      </button>
                    </CardHeaderToolbar>
                  </Permission>
                </CardHeader>
                <CardBody>
                  <DynamicSimpleTable
                    queryParams={
                      `limit=${filters?.limit || 10}` 
                      + `&type=${filters?.type}`
                      + `&partner=${filters?.partner || ""}`
                    }
                    searchBox={false}
                    source={{ url: `/reports/accounts-by-holding-type` }}
                    columns={[
                      {
                        title: "USER",
                        format: (row) =>
                          formatUsername(
                            row.userId,
                            row.username,
                            null,
                            null,
                            null
                          ),
                      },
                      { title: "EMAIL", key: "email" },
                      { title: "PHONE", key: "phone" },
                      { title: "USER GROUP", key: "userGroup" },
                      { title: "PARTNER", key: "partner" },
                      { title: "CURRENCY", key: "currency" },
                      { title: "TOTAL CASH", key: "cashBalance" },
                      { title: "TOTAL COST BASIS", key: "totalCostBasis" },
                      { title: "TOTAL UNITS", key: "totalQuantity" },
                    ]}
                    onError={(err) => cogoToast.error(errorMessage(err))}
                    refreshIcon={true}
                    ref={tableRef}
                  />
                </CardBody>
              </Card>
            );
          }}
        </FilterGroup.Content>
      </FilterGroup>
    </div>
  );
};
